var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 101,
    viewBox: "0 0 79 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3986 66.9716C24.2616 60.837 24.5706 58.7232 25.5795 51.2539C26.135 47.1408 26.9738 43.2004 27.0027 39.0169C27.0545 31.5358 28.965 21.9488 36.0968 17.8009C50.1298 9.63914 66.6211 30.8884 56.6392 43.3124C52.8402 48.0409 47.6756 50.9196 43.3654 55.1875C41.6368 56.8991 40.3877 58.9197 38.3369 60.4038C36.3703 61.8271 33.9264 63.5996 33.3298 65.8551C32.8258 67.7604 32.7403 70.381 30.9473 71.7088C28.4704 73.5432 29.4487 72.5216 26.6928 71.7926C24.7984 71.2915 22.4031 69.0468 21.1987 67.4204C20.3387 66.2593 19.0861 68.6284 19.7291 66.1977C20.2811 64.1112 20.4935 66.0246 19.1204 65.6614",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4042 75.9551C21.9492 73.8446 12.2276 68.6008 13.8132 72.326C15.7264 76.8205 17.4605 75.2804 20.8089 77.012C22.5212 77.8976 22.8096 83.9818 20.7636 83.5674C17.8413 82.9755 16.9574 78.5993 14.0267 77.824C11.3594 77.1184 10.6219 80.6793 11.8922 82.3465C13.5698 84.548 16.4657 83.4246 17.2104 86.3594C18.3871 90.9971 12.4251 88.716 10.9349 87.3054C9.43345 85.8842 8.15949 83.9483 7.09568 82.7455",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7002 65.8317C18.6671 66.1497 18.1713 68.2249 18.9946 68.4427C19.4379 68.56 19.7129 68.3451 20.0584 68.6772C20.4647 69.0679 20.7467 69.8089 21.1058 70.2938C21.4223 70.7212 22.6244 70.9968 22.7473 71.4578C22.9481 72.211 23.6124 72.7699 24.3 73.036C25.1915 73.3811 25.4092 73.932 26.4444 73.9734C26.7608 73.986 26.8417 73.8022 27.1216 73.8763C27.5538 73.9906 27.6857 74.2466 28.1079 73.9704C28.5752 73.6646 29.215 73.6328 29.5502 73.0697C30.0059 72.3041 30.9886 72.0979 29.5684 72.2719",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8083 35.5856C43.2372 35.1791 41.9138 34.9372 40.939 36.4593C40.2758 37.495 39.9751 38.6057 39.6642 39.7811C39.3619 40.9238 39.8203 42.0281 39.5358 43.1037C39.1597 44.5256 38.0841 43.992 37.0072 44.1705C35.9898 44.3391 35.2407 44.5066 34.5059 45.2914C33.7781 46.0686 33.6833 47.9184 33.4884 48.921C33.3207 49.7836 33.2472 51.692 32.4713 52.2535C32.0497 52.5587 30.1496 52.6993 31.5146 52.1464",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8503 54.9589C54.8858 56.1258 55.9811 57.1638 57.2461 58.0619C57.7766 58.4385 58.4476 59.0376 58.5598 58.081",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6106 44.0646C63.6951 45.1895 65.7465 46.3784 67.7963 47.5564C68.1373 47.7524 67.5403 46.6015 67.5165 46.5651",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.263 32.7404C67.6572 33.0152 70.0658 33.2074 72.4675 33.4057C73.5732 33.497 73.9836 33.7537 73.6235 32.7004",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0361 17.2587C57.9423 17.4204 59.6028 17.5297 61.4668 17.142C62.3392 16.9606 63.2036 16.6938 64.0922 16.5961C65.1481 16.4799 65.138 16.5977 64.2416 15.6765",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2529 5.16885C41.4948 6.95951 41.2878 8.09737 41.5945 9.98275C41.7599 10.9992 41.7992 12.2389 41.7403 13.2737C41.72 13.6301 41.7077 13.8327 41.869 14.1469C41.9293 14.2645 41.9144 13.0522 41.906 12.8641",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8657 9.07312C26.9351 11.1651 27.2731 13.2436 27.2573 15.3167C27.2493 16.3655 27.0761 16.3835 26.9131 15.2778",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5659 21.5303C19.102 23.7815 20.1696 26.354 21.1568 28.8808C21.2806 29.1974 21.4798 29.351 21.638 29.6231C21.9975 30.2412 21.4458 28.9139 21.3837 28.7323",
    stroke: "#00ADB5",
    strokeOpacity: 0.5,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.d7b0c29342331b86b6cb9b6c4b038026.svg";
export { ForwardRef as ReactComponent };